import React from 'react';
import { motion } from 'framer-motion';
import { goToCheckout } from '../lib/constants';
type Props = {
  label?: string;
  className?: string;
};
export function CtaButton({
  label = '🧶 QUIERO EL SISTEMA ¿QUÉ TEJO HOY?™',
  className = ''
}: Props) {
  return <motion.button type="button" onClick={goToCheckout} whileTap={{
    scale: 0.97
  }} animate={{
    scale: [1, 1.025, 1]
  }} transition={{
    duration: 2.2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`group relative w-full rounded-2xl bg-mauve px-5 py-4 text-center text-base font-extrabold leading-tight text-white shadow-[0_10px_30px_-8px_rgba(181,107,132,0.7)] ring-4 ring-mauve-soft/60 transition-colors hover:bg-plum sm:text-lg ${className}`} data-id="element-80" data-mp="hhj2kyb4rtyk">
      <span className="drop-shadow-sm" data-id="element-81" data-mp="vddbviftglc7">{label}</span>
    </motion.button>;
}